import React from 'react';
import './Footer.css'; 

export const Footer = () => {

  return (
    <footer>
      <div className="center">
        <div className="footer card">
          <div>
            <span>Feito unicamente por <strong>Felipe Palmeira</strong>.</span>
          </div>
          <div>Copyright &copy; 2025</div>
        </div>
      </div>
    </footer>
  );
};